import { Injectable } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { UtilService } from './util.service';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PushNotifService {
  fcmTokenSubject: BehaviorSubject<string>;
  fcmToken: Observable<string>;
  user = this.auth.currentUserValue;

  constructor(
    private auth: AuthService,
    private utilService: UtilService,
    private router: Router
  ) {
    this.fcmTokenSubject = new BehaviorSubject<string>(
      localStorage.getItem('notifToken')
    );
    this.fcmToken = this.fcmTokenSubject.asObservable();
    // LocalNotifications.addListener(
    //   'localNotificationActionPerformed',
    //   (payload) => {
    //     const route = payload.notification.extra.route;
    //     if (route) {
    //       this.router.navigateByUrl(route);
    //     }
    //   }
    // );
  }

  initPushNotif() {
    PushNotifications.removeAllListeners().then(() => {
      this.recievedNotif();
    });
    this.checkPermission();
    this.deliveriedNotif();
  }

  async checkPermission() {
    let permissionStat = await PushNotifications.checkPermissions();

    if (permissionStat.receive === 'prompt') {
      permissionStat = await PushNotifications.requestPermissions();
    }

    if (permissionStat.receive !== 'granted') {
      console.error('Permission Denied');
    }

    await PushNotifications.register();
  }

  async recievedNotif() {
    await PushNotifications.addListener('registration', (token) => {
      if (token && token.value) {
        this.storeNotifToken(token.value);
      }
    });

    await PushNotifications.addListener('registrationError', (err) => {
      console.error('Registration failed :', err.error);
    });

    await PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification) => {
        if ((await Capacitor.getPlatform()) === 'android') {
          LocalNotifications.schedule({
            notifications: [
              {
                id: Number(notification?.id),
                title: notification?.title,
                body: notification?.body,
              },
            ],
          });
        }
      }
    );

    await PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        // notfication perfomed
      }
    );
  }

  async deliveriedNotif() {
    const notifList = await PushNotifications.getDeliveredNotifications();
  }

  storeNotifToken(value) {
    if (!value) return;
    localStorage.setItem('notifToken', value);
    this.fcmTokenSubject.next(value);
  }

  public get fcmTokenValue() {
    return this.fcmTokenSubject.value;
  }

  async setFcmToken() {
    let body = {
      token: this.fcmTokenValue,
    };
    await this.utilService.apiPost('sys/fcmtoken/set', body).subscribe({
      next: (res) => {
        // success
      },
      error: (err) => {
        // error
      },
    });
  }

  async revokeFcmToken() {
    await this.utilService.apiPost('sys/fcmtoken/revoke', {}).subscribe({
      next: (res) => {
        // success
      },
      error: (err) => {
        // error
      },
    });
  }

  async notifikasiAbsenPulang() {
    let minutes = [1, 2, 3];
    let date = new Date();
    minutes.forEach(async (el) => {
      await LocalNotifications.schedule({
        notifications: [
          {
            id: Number(this.utilService.generateRandomNumber(5)),
            title: 'Pengingat Absensi',
            body: 'Jangan lupa melakukan absen pulang melalui fitur absensi mobile di Aplikasi SIKAP BADUNG. Jika Anda sudah absen pulang, silakan mengabaikan notifikasi ini.',
            largeBody:
              'Mohon untuk tidak lupa melakukan absen pulang melalui fitur absensi mobile di Aplikasi SIKAP BADUNG. Jika Anda sudah absen pulang, silakan mengabaikan notifikasi ini.',
            schedule: {
              at: new Date(date.getTime() + 1000 * (el * 60)),
            },
            extra: {
              route: '/mobile-absensi',
            },
          },
        ],
      });
    });
  }

  async setScheduledNotif(title = '', body = '', schedule) {
    await LocalNotifications.schedule({
      notifications: [
        {
          id: Number(this.utilService.generateRandomNumber(5)),
          title: title,
          body: body,
          schedule: {
            at: new Date(schedule),
            allowWhileIdle: true,
          },
        },
      ],
    });
  }

  async removeScheduledNotif() {
    const pendingNotifications = (await LocalNotifications.getPending())
      .notifications;

    if (pendingNotifications) {
      LocalNotifications.cancel({
        notifications: pendingNotifications,
      });
    }
  }
}
